

import { useEffect, useState } from "react";
import "./MindMappingReportAFirstSection.css";

/* ------------------------------------
   LOCAL NORMALIZERS (FILE-LEVEL)
-------------------------------------*/
const normalizeValue = (val = "") =>
  String(val).trim().replace(/\s+/g, " ").toLowerCase();

const normalizeAge = (age = "") => {
  const v = normalizeValue(age);

  if (v.includes("26")) return "<26";
  if (v.includes("27")) return "27-32";
  if (v.includes("33")) return "33-42";
  if (v.includes("43")) return ">43";

  return "<26"; // safe fallback
};

const normalizeGender = (gender = "") => {
  const v = normalizeValue(gender);

  if (v.startsWith("m")) return "Male";
  if (v.startsWith("f")) return "Female";

  return "Other";
};

/* ------------------------------------
   COMPONENT
-------------------------------------*/
const MindMappingReportAFirstSection = ({ res,toggle }) => {
  const [selectedAgeKey, setSelectedAgeKey] = useState("<26");
  const [selectedGender, setSelectedGender] = useState("Male");

  useEffect(() => {
    if (!res) return;

    setSelectedAgeKey(normalizeAge(res.age));
    setSelectedGender(normalizeGender(res.gender));
  }, [res]);

  /* ------------------------------------
     STATIC MAPPINGS (STRICT)
  -------------------------------------*/
  const ageMapping = {
    "<26": {
      id: "1 A",
      age: "< 26",
      type: "Tech, experiments",
      risk: "Very High",
      growth: "Fast & volatile",
    },
    "27-32": {
      id: "1 A",
      age: "27–32",
      type: "VC-backed, scalable",
      risk: "High",
      growth: "Aggressive",
    },
    "33-42": {
      id: "1 A",
      age: "33–42",
      type: "Profitable & scalable",
      risk: "Medium",
      growth: "Sustainable",
    },
    ">43": {
      id: "1 A",
      age: "> 43",
      type: "Niche & legacy",
      risk: "Low",
      growth: "Stable",
    },
  };

  const genderMapping = {
    Male: {
      easier: "Traditional VCs, aggressive growth capital",
      harder: "Grants & diversity funds",
    },
    Female: {
      easier: "Women-focused funds, grants, impact investors",
      harder: "Large late-stage VC cheques (improving)",
    },
    Other: {
      easier: "Impact funds, ESG investors, social grants",
      harder: "Mainstream VC networks",
    },
  };

  const activeRow = ageMapping[selectedAgeKey];
  const activeGender = genderMapping[selectedGender];

  // 🛑 HARD GUARD — PREVENTS CRASHES
  if (!activeRow || !activeGender) return null;

  /* ------------------------------------
     RENDER
  -----------------------------------
  /* ... imports and logic remain the same ... */

  return (
    <div className="mind-mapping-report-a-container">
      <div className={toggle?"table-adjust":"mind-mapping-report-a-final-table"}> 
        <div className="mind-mapping-report-a-module-title">
          <span className="module-prefix">Module 1:</span> Founder Age & Gender vs Startup Behavior
        </div>
        {/* Decorative Corners */}
        <span className="mind-mapping-report-a-corner mind-mapping-report-a-corner-top-left"></span>
        <span className="mind-mapping-report-a-corner mind-mapping-report-a-corner-top-right"></span>
        <span className="mind-mapping-report-a-corner mind-mapping-report-a-corner-bottom-left"></span>
        <span className="mind-mapping-report-a-corner mind-mapping-report-a-corner-bottom-right"></span>

        {/* SECTION 1A - Added main-stats class */}
        <div className="mind-mapping-report-a-table-scroll-wrapper">
          <table className="mind-mapping-report-a-inner-table mind-mapping-report-a-main-stats">
            <thead>
              <tr>
                <th>S.NO</th>
                <th>Age Group</th>
                <th>Best Startup Type</th>
                <th>Risk Level</th>
                <th>Growth Style</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{activeRow.id}</td>
                <td>{activeRow.age}</td>
                <td>{activeRow.type}</td>
                <td>{activeRow.risk}</td>
                <td>{activeRow.growth}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* SECTION 1B - Added gender-stats class */}
        <div className="mind-mapping-report-a-table-scroll-wrapper">
          <table className="mind-mapping-report-a-inner-table mind-mapping-report-a-gender-stats">
            <thead>
              <tr>
                <th>S.NO</th>
                <th>Gender</th>
                <th>Easier Access To</th>
                <th>Harder Access To</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 B</td>
                <td>{selectedGender}</td>
                <td>{activeGender.easier}</td>
                <td>{activeGender.harder}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MindMappingReportAFirstSection;